import Card, { CardProps } from '@components/Card';
import { Entry, EntrySectionId, isEntry } from '@lib/features/entries';
import { useEvent } from '@lib/hooks';

export type EntryCardProps<T extends EntrySectionId = EntrySectionId> = CardProps<Entry<T>>;

const EntryCard = ({ item, ...props }: EntryCardProps) => {
  const { eventDateFormatted } = useEvent(item);

  if (!item) return null;

  if (isEntry(item, 'eventPerformance')) {
    // Convert performance to event
    const performanceDate = item.eventDateStart;
    const event = item.eventSingle[0];

    if (!isEntry(event, 'event')) return null;

    event.eventDateStart = performanceDate;
    event.eventDateEnd = performanceDate;
    event.title = item.title ?? event.title;
    event.entrySummary = item.entrySummary ?? event.entrySummary;
    event.entryImage = item.entryImage ?? event.entryImage;

    item = event;
  }

  const { uri: href, title, entrySummary: description, entryImage: image } = item;
  const meta: string[] = [];

  switch (true) {
    case isEntry(item, 'event'):
      if (eventDateFormatted) meta.push(eventDateFormatted);
      break;

    default:
      break;
  }

  return (
    <Card
      {...props}
      padding="lg"
      item={{
        meta,
        title,
        description,
        href,
        image,
      }}>
      <Card.Image />
      <Card.Body>
        <Card.Meta />
        <Card.Title />
        <Card.Description />
      </Card.Body>
      <Card.Foot />
    </Card>
  );
};

export default EntryCard;
